import React from 'react';
import { FormGroup } from 'react-bootstrap';
import cx from 'classnames';
import {
  Field,
  useFormikContext,
} from 'formik';
import { PlantChoiceFormValues } from './PlantChoice';

export function OfflineForm (props: {
  onChange: any,
}) {
  const {
    values,
    touched,
    errors,
  } = useFormikContext<PlantChoiceFormValues>();
  return (
    <>
      <FormGroup className={cx({'has-error': errors.locationId && touched.locationId})}>
        <Field
          type="number"
          min={0}
          max={100}
          name="locationId"
          placeholder="Location ID"
          value={values.locationId || ''}
          onChange={props.onChange}
          className="form-control input-sm"
        />
      </FormGroup>
      <FormGroup className={cx({'has-error': errors.plantId && touched.plantId})}>
        <Field
          type="number"
          min={0}
          max={100}
          name="plantId"
          placeholder="Plant ID"
          value={values.plantId || ''}
          onChange={props.onChange}
          className="form-control input-sm"
        />
      </FormGroup>
    </>
  );
}
